// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"2b4262a1","297":"13b0c78e","407":"7e078f49","422":"51277a6f","524":"24226590","723":"2b7db526"}[chunkId] + ".chunk.js";
};